import { render, staticRenderFns } from "./bfafter.vue?vue&type=template&id=787cfff6&scoped=true&"
import script from "./bfafter.vue?vue&type=script&lang=js&"
export * from "./bfafter.vue?vue&type=script&lang=js&"
import style0 from "./bfafter.vue?vue&type=style&index=0&id=787cfff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787cfff6",
  null
  
)

export default component.exports